import React, { FunctionComponent } from 'react';
import {
  Distance,
  DistanceUnit,
  Duration,
  TimeUnit,
} from '../../../types/__generated__';
import { FormattedDistance } from './FormattedDistance';
import { FormattedDuration } from './FormattedDuration';

export type FormattedMeasurementProps = { value: Distance | Duration };

const isDistanceUnit = (unit: DistanceUnit | TimeUnit) =>
  Object.values(DistanceUnit).includes(unit as DistanceUnit);

export const FormattedMeasurement: FunctionComponent<FormattedMeasurementProps> = ({
  value,
}) => {
  return isDistanceUnit(value.unit) ? (
    <FormattedDistance value={value as Distance}></FormattedDistance>
  ) : (
    <FormattedDuration value={value as Duration}></FormattedDuration>
  );
};
